module.exports = __webpack_public_path__ + "img/text09.4973f623.svg";